<template>
    <div class="navbar-quarry-container">
        <div class="container-fluid">
            <nav class="navbar">
                <div class="navbar-header">
                    <button type="button" class="navbar-toggle collapsed" data-toggle="collapse" data-target="#bs-app-navbar-collapse" aria-expanded="false">
                        <span class="sr-only">Toggle navigation</span>
                        <span class="icon-bar"></span>
                        <span class="icon-bar"></span>
                        <span class="icon-bar"></span>
                    </button>
                    <a class="navbar-brand" href=".">{{title}}</a>
                    <span v-show="!!currentUser" class="login-indicator hidden-xs hidden-md text-nowrap">(Login: {{currentUser?currentUser.name:"Not logged in"}})</span>
                </div>
                <div class="collapse navbar-collapse" id="bs-app-navbar-collapse">
                    <ul class="nav navbar-nav navbar-right">
                        <!-- Display Submenus -->
                        <li v-for='(routes,key) in routeSubmenus' :key='key' class="dropdown">
                            <a href="#" class="dropdown-toggle" data-toggle="dropdown" role="button" aria-haspopup="true" aria-expanded="false">{{key}}<span class="caret"></span></a>
                            <ul class="dropdown-menu">
                                <li v-for='route in routes' :key='route.path'>
                                    <!-- One link for large displays, another for smaller displays that autocloses the navbar -->
                                    <router-link
                                        @click.native="handleRouterLink"
                                        :to="route.path"
                                        v-html="route.name"
                                        class="hidden-sm hidden-xs"
                                    ></router-link>
                                    <router-link
                                        @click.native="handleRouterLink"
                                        :to="route.path"
                                        v-html="route.name"
                                        class="visible-sm visible-xs"
                                        data-toggle="collapse"
                                        data-target="#bs-app-navbar-collapse"
                                    ></router-link>
                                </li>
                            </ul>
                        </li>
                        <!-- Root-level menu options -->
                        <li v-for="route in routesRoot" :key="route.path">
                            <!-- One link for large displays, another for smaller displays that autocloses the navbar -->
                            <router-link
                                @click.native="handleRouterLink"
                                :to="route.path"
                                v-html="route.name"
                                class="hidden-sm hidden-xs"
                            ></router-link>
                            <router-link
                                @click.native="handleRouterLink"
                                :to="route.path"
                                v-html="route.name"
                                class="visible-sm visible-xs"
                                data-toggle="collapse"
                                data-target="#bs-app-navbar-collapse"
                            ></router-link>
                        </li>
                        <li v-show="!!currentUser">
                            <router-link
                                to="/logout"
                                data-toggle="collapse"
                                data-target="#bs-app-navbar-collapse"
                            >Logout</router-link>
                        </li>
                    </ul>
                </div>
            </nav>
        </div>
    </div>
</template>

<script>
/* eslint-env jquery */
export default {
    props: {
        title: {default: 'Untitled'}
    },
    computed: {

        /**
         * @returns {array} All routes that have names. These are the routes that are used for the navbar.
         */
        routesWithNames() {
            return this.$router.options.routes.filter(route=>route.name);
        },

        /**
         * @returns {array} Routes that are on the root level of the menu (no defined submenu).
         */
        routesRoot() {
            return this.routesWithNames.filter(this.routeIsRoot);
        },

        /**
         * @returns {object} Object where the keys are submenu names, and they contain an array of routes belonging to that submenu.
         */
        routeSubmenus() {
            var submenus = {};
            this.routesWithNames.forEach(route=>{
                if (!this.routeIsRoot(route)) {
                    if (!submenus.hasOwnProperty(route.submenu)) submenus[route.submenu] = [];
                    submenus[route.submenu].push(route);
                }
            });
            return submenus;
        },

        /**
         * @returns {User} Current user from the Vuex store.
         */
        currentUser() {
            return this.$store.getters.currentUser;
        }
    },
    methods: {

        /**
         * @returns {boolean} Boolean whether a route is root-level or not. Basically, does it have a submenu?
         * @param {object} route The route to evaluate.
         */
        routeIsRoot(route) {
            return !route.submenu || route.submenu.length === 0;
        },

        /**
         * Receives text and updates the breadcrumb with that text.
         * @returns {void}
         * @param {string} text - The text for the breadcrumb.
         */
        updateBreadcrumbTitle(text) {
            $('#CS_Element_BreadcrumbTitle span:last').text(text ? text : 'Home');
        },

        /**
         * Handler for when a router link is clicked.
         * @returns {void}
         * @param {object} event - The event object triggered by the click.
         */
        handleRouterLink(event) {
            this.updateBreadcrumbTitle(event.target.text);
        }
    },
    mounted() {
        this.updateBreadcrumbTitle(this.$route.name);
    },
    updated() {
        this.updateBreadcrumbTitle(this.$route.name);
    },
    data() {
        return {
            login: {id: '', name: ''}
        };
    }
};
</script>

<style scoped>
.navbar-brand {
    display: inline-block !important;
}
.navbar-fixed-top .login-indicator {
    display: none;
}
.login-indicator {
    color: white;
    padding-left: 10px;
}
</style>